import React from 'react';

// Item de localização (Recebe o objeto 'city')
const LocationItem = ({ city }) => (
    <div className="flex items-center space-x-4 pr-12 whitespace-nowrap">

        <span className="bg-[#FF770033] text-[#FF7700] text-sm font-medium px-4 py-0 rounded-lg flex items-center shadow-sm">
            <svg className="w-5 h-5 mr-2 mt-1" width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_696_2282)">
                    <path d="M20.0003 6.79244V7.94407C19.8394 10.0949 19.0487 12.1453 17.7336 13.8042C17.5425 14.045 17.042 14.6751 16.768 14.7206C16.3128 14.7968 16.0128 14.3976 16.1029 13.938C16.143 13.7351 16.6076 13.2981 16.7571 13.1045C19.5024 9.56129 19.4951 5.14176 16.7394 1.60954C16.5909 1.41925 16.143 1.00137 16.1029 0.798461C15.992 0.236903 16.4909 -0.199072 16.967 0.09432C17.1524 0.208935 17.5769 0.735396 17.7336 0.93227C19.0154 2.54236 19.8826 4.69098 20.0003 6.79244Z" fill="#FF7700" />
                    <path d="M3.8974 13.938C4.00521 14.4853 3.53854 14.918 3.05885 14.6564C2.74219 14.4837 1.9401 13.3836 1.7099 13.0326C0.761979 11.586 0.103125 9.74061 0 7.98519V6.7513C0.173958 4.61694 0.95625 2.578 2.26667 0.932262C2.45885 0.690968 2.95729 0.0614086 3.23229 0.0158916C3.7276 -0.0669162 4.06406 0.444189 3.85 0.913068C0.566666 4.39264 0.286458 9.3145 3.26094 13.127C3.40937 13.3173 3.85729 13.7351 3.8974 13.938Z" fill="#FF7700" />
                    <path d="M9.75707 4.95311C7.8477 5.18015 7.16384 7.76638 8.69822 9.00631C8.92634 9.19057 9.17009 9.27393 9.40916 9.40993L9.41332 16.4793C9.53624 17.2229 10.4644 17.2229 10.5873 16.4793L10.5914 9.40993C10.8383 9.27064 11.0925 9.1818 11.3253 8.98931C13.0232 7.58322 11.893 4.69865 9.75707 4.95311ZM10.1326 8.22704C8.82374 8.37785 8.63416 6.38442 9.83363 6.18536C11.1711 5.9638 11.3842 8.08281 10.1326 8.22704Z" fill="#FF7700" />
                    <path d="M5.68655 12.1377C5.78446 12.6778 5.24332 13.0529 4.77665 12.765C4.5678 12.6356 4.11207 12.0137 3.95217 11.7823C2.09905 9.09899 2.17248 5.39073 4.0855 2.76611C4.2855 2.49191 4.70269 1.91609 5.02925 1.86564C5.40113 1.80806 5.74592 2.17384 5.69488 2.56539C5.65582 2.87085 5.35842 3.06279 5.19592 3.27721C3.47613 5.53935 3.2454 8.61366 4.87352 11.0173C5.06259 11.2959 5.63811 11.8711 5.68655 12.1377Z" fill="#FF7700" />
                    <path d="M16.5301 10.974C16.3004 11.4198 15.6645 12.4278 15.2926 12.7151C15.003 12.9389 14.6285 12.9421 14.4134 12.6126C14.0478 12.051 14.6639 11.6474 14.9598 11.2536C16.5816 9.09734 16.64 5.95393 15.1259 3.71921C14.9369 3.44063 14.3613 2.86536 14.3129 2.59884C14.254 2.27529 14.4811 1.91334 14.7952 1.86563C15.0613 1.8256 15.2535 1.97641 15.4306 2.16451C17.579 4.442 17.9707 8.17768 16.5301 10.974Z" fill="#FF7700" />
                    <path d="M7.45823 10.3137C7.50615 10.7902 7.10511 11.0869 6.67854 10.9685C6.39573 10.8901 5.8624 10.0866 5.71083 9.80752C4.89521 8.30546 4.90198 6.39923 5.72594 4.90375C5.92073 4.54949 6.44729 3.73457 6.86136 3.72196C7.06292 3.71538 7.31969 3.88209 7.4025 4.07732C7.61813 4.58514 7.20667 4.82149 6.95979 5.17466C6.04469 6.48368 6.04625 8.25501 6.95979 9.56183C7.11656 9.78613 7.43115 10.0428 7.45823 10.3137Z" fill="#FF7700" />
                    <path d="M13.7702 10.5769C13.4932 10.9005 13.1286 11.2076 12.7333 10.8451C12.2161 10.3707 12.7729 9.94352 13.0239 9.58596C13.9593 8.25501 13.9567 6.48204 13.0239 5.15053C12.7989 4.82972 12.4645 4.65588 12.5567 4.19907C12.6072 3.94516 12.8676 3.72964 13.1114 3.72196C13.5473 3.70825 14.1067 4.58678 14.3036 4.9553C15.2364 6.69975 15.0531 9.07705 13.7702 10.5769Z" fill="#FF7700" />
                </g>
                <defs>
                    <clipPath id="clip0_696_2282">
                        <rect width="20" height="17.037" fill="white" />
                    </clipPath>
                </defs>
            </svg>

            conectado em
        </span>

        <span className="text-gray-600 text-sm font-bold">
            {`${city.name} - ${city.state}`}
        </span>
        <span className="text-gray-600 text-sm font-medium ml-2">
            • {city.address}
        </span>
        <span className="text-gray-600 text-sm font-medium ml-2">
            • {city.neighborhood}
        </span>
        <span className="text-gray-600 text-sm font-medium ml-2">
            • {city.cep}
        </span>
        <span className="text-gray-600 text-sm font-medium ml-2">
            ⸬
        </span>
    </div>
);

// Componente Principal
export default function LocationMarquee({ city, active }) {

    // Verificações básicas 
    // Nota: Adicionei a verificação para city.state e city.neighborhood para evitar erros de renderização
    if (!city || !city.name || !city.address || !city.state || !city.neighborhood) {
        return null;
    }

    // Criamos um array para replicar o objeto único 5 vezes
    const REPETITION_COUNT = 5;
    const repeatedCity = new Array(REPETITION_COUNT).fill(city);

    return (
        <div className="w-full flex justify-center">
            <div
                // CLASSE DE LARGURA AJUSTADA: 
                // max-w-[300px] em mobile, md:max-w-6xl em desktop
                className="max-w-[300px] md:max-w-6xl w-full bg-white/70 overflow-hidden py-2 relative rounded-b-md border-b border-gray-200"
            >
                <div
                    // w-[max-content] CRUCIAL para garantir que todos os 5 itens caibam em uma linha
                    // animate-marquee deve ser definido em seu CSS global!
                    className="flex w-[max-content] animate-marquee"
                >
                    {repeatedCity.map((item, index) => (
                        <LocationItem key={index} city={item} />
                    ))}
                </div>
            </div>
        </div>
    );
}